import React from 'react';
import { cn } from '../../../lib/utils';
import { useFooterContent } from '@/contexts/FooterContext';
import { FooterLeftWell } from './FooterLeftWell';
import { FooterRightWell } from './FooterRightWell';
import { FooterSystemControls } from './FooterSystemControls';

export interface FooterProps extends React.HTMLAttributes<HTMLElement> {
  children?: React.ReactNode;
  className?: string;
}

/**
 * Footer - Bottom section of ThreePane layout
 * Reads from FooterContext to render page-specific content in wells
 * System controls (admin/dev/keyboard shortcuts) always visible on right
 */
export const Footer = React.forwardRef<HTMLElement, FooterProps>(
  ({ children, className, ...props }, ref) => {
    const { content } = useFooterContent();

    return (
      <footer
        ref={ref}
        className={cn(
          'w-full border-t border-border bg-background',
          className
        )}
        {...props}
      >
        <div className="flex items-center px-8 py-3">
          {/* Left well - page-specific controls (always rendered for layout) */}
          <FooterLeftWell content={content.left} />

          {/* Right section: view well + system controls */}
          <div className="flex items-center gap-4">
            <FooterRightWell content={content.right} />
            <FooterSystemControls />
          </div>
        </div>

        {/* Legacy children support (for backward compatibility during migration) */}
        {children}
      </footer>
    );
  }
);

Footer.displayName = 'Footer';
